<template>
    <div v-wechat-title="title" class="padding10" :style="{ height: this.screenHeight + 'px' }" style="width: 80%; margin: auto">
        <el-row type="flex" align="middle">
            <el-col :xl="24" class="align-right">
                <el-button type="primary" size="mini" v-if="this.permissions && this.permissions.findIndex(item => item.permission === `Desltop:DisArchive`) != -1" @click="UnArchive"
                    >取消归档</el-button
                >
                <el-button type="primary" size="mini" @click="vitalsign">监护数据</el-button>
                <el-button type="primary" size="mini" @click="goprint">打印</el-button>
            </el-col>
        </el-row>
        <el-main class="width-p100" :style="{ height: this.screenHeight + 'px' }" style="padding: 0px; margin-top: 10px; padding-bottom: 50px" v-loading="loading">
            <pdf v-for="i in numPages" :key="i" :src="src" :page="i"></pdf>
        </el-main>
        <!-- <CreateVitalSign :visible.sync="alterPasswordDialogVisible"></CreateVitalSign> -->
        <cus-dialog class="table-h360" title="监护数据" :visible.sync="jhsjdialogFormVisible" :close-on-click-modal="false" width="80%" @confirm="closewbase()">
            <iframe frameborder="0" :src="jhsjurl" :height="500" width="100%"></iframe>
        </cus-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import pdf from '@/common/vue-pdf-4.1.0'
import CreateVitalSign from '@/components/Anesthsia/CreateVitalSign.vue'
import printJs from 'print-js'
export default {
    name: `AnesthesiaDesk`,
    components: { pdf, CreateVitalSign },
    prop: {

    },
    data() {
        return {
            title: `麻醉单`,
            surgeryId: this.$route.query.surgery_id,
            recordtype: this.$route.query.record_type,
            token: this.$route.query.token,
            surgeryinfo: {},
            src: undefined,
            numPages: 0,
            loading: false,
            permissions: [],
            timeStep: 1,
            jhsjdialogFormVisible: false,
            pdfcontent: ``,
            isShowSendPrintMessage: this.$root.isShowSendPrintMessage,
            pdfsrc: ``
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
        }
        this.$store.dispatch(`ADD_CURRENTUSER`)
        this.loadPermissions()
    },
    computed: {
        ...mapGetters([`screenHeight`, `currentUser`, `sys_document_list`]),
        jhsjurl() {
            let inroom = this.surgeryinfo.in_room == null ? this.$moment().format(`YYYY/MM/DD HH:mm`) : this.$moment(this.surgeryinfo.in_room).format(`YYYY/MM/DD HH:mm`)
            let outroom = this.surgeryinfo.out_room == null ? this.$moment().format(`YYYY/MM/DD HH:mm`) : this.$moment(this.surgeryinfo.out_room).format(`YYYY/MM/DD HH:mm`)
            let r = `/#/vital_sign?surgery_id=${this.surgeryId}&record_type=${this.recordtype}&begin_time=${inroom}&end_time=${outroom}&step=${this.timeStep}&token=${this.token}`

            return r
        }
    },
    mounted() {
        this.loadpdf()
        this.SetTimeStep()
        console.log(winformMsg)
    },
    methods: {
        closewbase() {
            this.jhsjdialogFormVisible = false
        },
        loadPermissions() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(data => {
                this.permissions = data
                console.log(this.permissions)
            }).catch(e => {
            })
        },
        loadpdf() {
            this.loading = true
            let req = this.myaxios.get(`/api/Operation/Home/ArchivePdf?surgeryInfoId=${this.surgeryId}&recordType=${this.recordtype}`)
            req.then(data => {
                this.src = pdf.createLoadingTask(`data:application/pdf;base64,${data}`)
                this.src.then(content => {
                    this.pdfcontent = data
                    console.log(content.numPages)
                    this.numPages = content.numPages
                    this.loading = false
                })
            }).catch(e => {
                console.log(e)
                this.loading = false
            })
        },
        UnArchive() {
            this.$confirm(`取消归档后，必须重新打开当前单据才能继续编辑，是否确定取消归档?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            }).then(() => {
                let req = this.myaxios.put(`/api/Operation/Home/UnArchive?surgeryInfoId=${this.surgeryId}&&recordType=${this.recordtype}`)
                req.then(data => {
                    let action = `closeAnes`
                    if (this.recordtype == 2) {
                        action = `closeRev`
                    }
                    let r = typeof winformMsg
                    console.log(winformMsg)
                    if (r != `undefined`) {
                        var cefJson = {
                            action: action,
                            id: this.surgeryId
                        }
                        console.log(cefJson)
                        winformMsg.acceptMessage(cefJson)
                    }
                })
            })
        },
        vitalsign() {
            this.jhsjdialogFormVisible = true
            // let r = `/#/vital_sign?surgery_id={0}&record_type={1}&begin_time={0}&end_time={1}&step={2}`
            // this.$router.push({
            //     path: r
            // })
        },
        SetTimeStep() {
            let req = this.myaxios.get(`/api/AcisSystem/RecordConfig/GetTimeStep?surgeryInfoId=${this.surgeryId}&recordType=${this.recordtype}`)
            req.then(data => {
                if (data != null) {
                    this.timeStep = data
                }
            })
            let req2 = this.myaxios.get(`/api/Preoperative/Apply/Get/${this.surgeryId}`)
            req2.then(data => {
                this.surgeryinfo = data
            })
        },
        goprint() {
            let that = this
            if (this.pdfcontent != ``) {
                this.myaxios.post(`/api/Operation/Home/SetPrintMapRecord?surgeryInfoId=${that.surgeryId}&recordType=${that.recordtype}`).then(data => {
                    printJs({ printable: this.pdfcontent,
                        type: `pdf`,
                        base64: true,
                        onPrintDialogClose: () => {
                            if (that.isShowSendPrintMessage === `true`) {
                                setTimeout(function() {
                                    that.$confirm(`提示`, {
                                        title: `提示`,
                                        message: `请确认打印是否已完成`,
                                        confirmButtonText: `打印完成`,
                                        cancelButtonText: `打印未完成`,
                                        type: `warning`
                                    }).then(() => {

                                    }).catch(e => {
                                        console.log(e)
                                    })
                                }, 2000)
                            }
                        } })
                })
            }
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.active_item = {}
            this.loadScore()
        }
    }
}
</script>
<style scoped lang="less">
.score-item {
    border: solid 0.5px lightgray;
    box-shadow: 2px 2px 5px lightgrey;
    height: 120px;
    overflow: hidden;
    position: relative;
    &.scored:hover {
        .score-left {
            width: 80%;
        }
        .score-delete {
            left: 80%;
        }
        .score {
            left: 80%;
        }
    }
    .score-main {
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .score-delete {
        width: 20%;
        position: absolute;
        left: 100%;
        top: 0;
        // background: darkcyan;
        height: 100%;
        align-items: center;
        display: flex;
        justify-content: center;
        color: white;
        opacity: 0.7;
        &:hover {
            opacity: 0.8;
        }
    }
    .score {
        width: 20%;
        position: absolute;
        left: 100%;
        top: 0;
        // background: darkcyan;
        height: 100%;
    }
    .score-delete-new {
        background-color: #e63939;
        width: 100%;
        height: 50%;
        align-items: center;
        display: flex;
        justify-content: center;
        color: white;
        opacity: 0.7;
        &:hover {
            opacity: 1;
        }
    }
    .score-add {
        width: 100%;
        height: 50%;
        align-items: center;
        display: flex;
        justify-content: center;
        color: white;
        opacity: 0.7;
        &:hover {
            opacity: 1;
        }
    }
}

.score-record {
    text-align: left;
    color: black;
    border: solid;
    border-width: 2px 0px 5px 0px;
    background: white;
    border-color: #fafafa;
    &:hover {
        background: var(--primary-light, #e6f5f3);
        cursor: pointer;
    }
}
.score-record-active {
    text-align: left;
    color: black;
    border: solid;
    border-width: 2px 0px 5px 0px;
    background: var(--primary-lighter, #d7f3ef);
    border-color: #fafafa;
    &:hover {
        background: var(--primary-light, #e6f5f3);
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/AnesthesiaDesk/Index.vue